'use client';
import { ErrorPage } from './(pages)/components/ErrorPage';

export default function GlobalError({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>) {
  console.error('Error:', error);

  return (
    <html lang="en">
      <body>
        <ErrorPage error={error} reset={reset}></ErrorPage>
      </body>
    </html>
  );
}
